export enum ReportsTableColumnTitle {
  Report = "Izvještaj",
  Options = "",
}
